import _ from 'lodash';
import { Param } from '../Param';

export class SingleSortOrder {
	constructor({
		id = "sortOrder",
		orders = ['asc', 'desc'],
		current = 'asc'
		} = {}) {
		this.id = id;
		this.type = 'SortOrder';
		this.orders = orders;
		this.current = current;
	}

	flip() {
		var currentIndex = _.indexOf(this.orders, this.current);
		this.current = currentIndex === 0 ? this.orders[1] : this.orders[0];
	}


	toParam() {
		return new Param({ id: this.id, value: this.current });
	}
}
